<template>
  <span class="tooltip" :class="getBrowserInfo">
    <i class="icon" :class="`icon--info-${iconSize}`"
      @mouseenter="showText = true"
      @mouseleave="showText = false"></i>
      <ui-tooltip v-show="showText || forceShowText"
                  :style="tooltipStyle"
                  :arrowBottom="arrowBottom"
                  :arrowLeft="arrowLeft"
                  :arrowTop="arrowTop"
                  :arrowRight="arrowRight"
                  :arrowCenter="arrowCenter">
      <slot/>
    </ui-tooltip>
  </span>
</template>

<script>
import UiTooltip from './UiTooltip'
import { browserInfo } from '@/libs/utils'

export default {
  name: 'UiIconTooltip',
  components: {
    UiTooltip
  },
  props: {
    arrowBottom: {
      type: Boolean,
      default: false
    },
    arrowLeft: {
      type: Boolean,
      default: false
    },
    arrowTop: {
      type: Boolean,
      default: false
    },
    arrowRight: {
      type: Boolean,
      default: false
    },
    arrowCenter: {
      type: Boolean,
      default: false
    },
    iconSize: {
      type: String,
      default: 'small'
    },
    forceShowText: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showText: false
    }
  },
  computed: {
    tooltipStyle () {
      const isLeft = !this.arrowRight && !this.arrowCenter
      const isBottom = !this.arrowTop
      const yOffset = this.iconSize === 'normal' ? 4 : 0
      const xOffset = this.iconSize === 'normal' ? 2 : 0
      const result = {
        top: !isBottom ? `${27 + yOffset}px` : 'auto',
        bottom: isBottom ? `${27 + yOffset}px` : 'auto'
      }

      if (this.iconSize === '14') {
        result.top = `${24 + yOffset}px`
      }

      if (this.arrowCenter) {
        result.transform = 'translateX(-50%)'
        result.marginLeft = `${-8 - xOffset}px`
      } else {
        result.left = isLeft ? `${-13 + xOffset}px` : 'auto'
        result.right = !isLeft ? `${-13 + xOffset}px` : 'auto'
      }
      return result
    },
    getBrowserInfo () {
      return 'browser-' + browserInfo.name
    }
  }
}
</script>

<style lang="scss">
.tooltip {
  position: relative;
  display: inline-block;
  vertical-align: top;
}
</style>
